import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { WidgetKind } from "../models/dashboard.dto";
import { CalendarType } from "./widgets/calendar/calendar-types";
import { Widget } from "../models/dashboard.model";

@Component ({
    selector: 'widget',
    templateUrl: './widget.component.html',
    standalone: false
})

export class WidgetComponent {
    @Input() widget: Widget;
    @Input() editDashboard: boolean;

    @Output() deleteWidget = new EventEmitter();

    calendarTypes = CalendarType;

    widgetKinds = WidgetKind;

    constructor( ) {}

    delete(): void {
        this.deleteWidget.emit(this);
    }
}